export default __webpack_public_path__ + "static/media/more.a61a8dc2.svg";